import React from 'react';
import {SvgIcon} from '@website/components/shared/icons/SvgIcon';

export const FilterIcon: SvgIcon = ({
  width = 22,
  height = 17,
  strokeColor = 'text-black',
  strokeWidth = 1.2,
  fillColor = 'none',
  classes = '',
  title = 'Custom Icon',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 17"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <title>{title}</title>
    <path
      strokeWidth={strokeWidth}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.75 6C8.85457 6 9.75 5.10457 9.75 4C9.75 2.89543 8.85457 2 7.75 2C6.64543 2 5.75 2.89543 5.75 4C5.75 5.10457 6.64543 6 7.75 6ZM7.75 7.5C9.42704 7.5 10.8286 6.3205 11.1704 4.74582C11.1965 4.74858 11.2231 4.75 11.25 4.75H21.25C21.6642 4.75 22 4.41421 22 4C22 3.58579 21.6642 3.25 21.25 3.25H11.25C11.2231 3.25 11.1965 3.25142 11.1704 3.25418C10.8286 1.6795 9.42704 0.5 7.75 0.5C6.07296 0.5 4.6714 1.67949 4.32964 3.25418C4.30347 3.25142 4.2769 3.25 4.25 3.25H1.25C0.835786 3.25 0.5 3.58579 0.5 4C0.5 4.41421 0.835786 4.75 1.25 4.75H4.25C4.2769 4.75 4.30347 4.74858 4.32964 4.74582C4.6714 6.32051 6.07296 7.5 7.75 7.5ZM14.75 15C13.6454 15 12.75 14.1046 12.75 13C12.75 11.8954 13.6454 11 14.75 11C15.8546 11 16.75 11.8954 16.75 13C16.75 14.1046 15.8546 15 14.75 15ZM14.75 16.5C13.073 16.5 11.6714 15.3205 11.3296 13.7458C11.3035 13.7486 11.2769 13.75 11.25 13.75H1.25C0.835787 13.75 0.5 13.4142 0.5 13C0.5 12.5858 0.835787 12.25 1.25 12.25H11.25C11.2769 12.25 11.3035 12.2514 11.3296 12.2542C11.6714 10.6795 13.073 9.5 14.75 9.5C16.427 9.5 17.8286 10.6795 18.1704 12.2542C18.1965 12.2514 18.2231 12.25 18.25 12.25H21.25C21.6642 12.25 22 12.5858 22 13C22 13.4142 21.6642 13.75 21.25 13.75H18.25C18.2231 13.75 18.1965 13.7486 18.1704 13.7458C17.8286 15.3205 16.427 16.5 14.75 16.5Z"
      fill="white"
    />
  </svg>
);
